import { CmsPagePage } from './CmsPagePage'

/**
 * `customer-cms` — the franchise's own pages, written in the manager and rendered here.
 *
 * One route. The content is whatever an admin typed, which is why it renders inside a sandboxed frame
 * with no `allow-same-origin`: scripts run at a null origin with no access to the customer's session.
 * Replacing that with `dangerouslySetInnerHTML` would turn the CMS editor into stored XSS.
 */
export const customerCmsModule = {
  name: 'customer-cms',
  routes: [{ path: '/page/:slug', page: 'CmsPage', component: CmsPagePage }],
} as const

export { CmsPagePage }
export {
  FRAME_SANDBOX,
  MAX_FRAME_HEIGHT,
  MIN_FRAME_HEIGHT,
  buildFrameDocument,
  heightFromMessage,
  looksLikeHtml,
  type FrameColours,
} from './cms-frame'

// §9.169 — the manager's editor previews with the same renderer the customer page uses.
export { renderMarkdown } from './markdown'
